import { getIpInfoCached } from './getIpInfoCached';

export const getIpData = async () => {
  const ipInfoRes = await getIpInfoCached();

  const ipData = {
    ipcity: ipInfoRes?.ipCity ? decodeURIComponent(ipInfoRes.ipCity) : '',
    ipcountry: ipInfoRes?.ipCountry,
    ipCountryCode: ipInfoRes?.ipCountryCode,
    ipCountryRegion: ipInfoRes?.ipCountryRegion,
    fr_ip: ipInfoRes?.realIp,
  };

  return ipData;
};
